/* ============================================================
   Collection Custom — collection-custom.js
   ============================================================ */

(function () {
  "use strict";

  if (window.__ccInit) return;
  window.__ccInit = true;

  /* WH-172: bounded/retrying fetch with plain-fetch fallback; cart POSTs are
     duplicate-safe via cartMutate. */
  var ehFetch = function (url, opts) {
    return window.EH && window.EH.fetchRetry ? window.EH.fetchRetry(url, opts) : fetch(url, opts);
  };
  var ehCartPost = function (url, payload) {
    return window.EH && window.EH.cartMutate
      ? window.EH.cartMutate(url, payload)
      : fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
  };

  /* ── Category strip ── */
  function initCategoryStrip() {
    var inner = document.getElementById("catStripInner");
    var scroll = document.getElementById("catStripScroll");
    var btnLeft = document.getElementById("catArrowLeft");
    var btnRight = document.getElementById("catArrowRight");
    if (!inner || !scroll) return;

    function updateArrows() {
      var canLeft = scroll.scrollLeft > 4;
      var canRight =
        scroll.scrollLeft < scroll.scrollWidth - scroll.clientWidth - 4;
      inner.classList.toggle("can-scroll-left", canLeft);
      inner.classList.toggle("can-scroll-right", canRight);
    }

    scroll.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    updateArrows();

    if (btnLeft) {
      btnLeft.addEventListener("click", function () {
        scroll.scrollBy({ left: -240, behavior: "smooth" });
      });
    }
    if (btnRight) {
      btnRight.addEventListener("click", function () {
        scroll.scrollBy({ left: 240, behavior: "smooth" });
      });
    }
  }

  /* ── Filter drawer ── */
  function initFilterDrawer() {
    var filterBtn = document.getElementById("filterBtn");
    var drawer = document.getElementById("filterDrawer");
    var overlay = document.getElementById("filterOverlay");
    var closeBtn = document.getElementById("filterClose");
    var resetBtn = document.getElementById("filterResetBtn");
    var applyBtn = document.getElementById("filterApplyBtn");
    if (!filterBtn || !drawer) return;

    function openDrawer() {
      drawer.classList.add("is-open");
      if (overlay) overlay.classList.add("is-open");
      filterBtn.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      if (overlay) overlay.classList.remove("is-open");
      filterBtn.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }

    filterBtn.addEventListener("click", openDrawer);
    if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
    if (overlay) overlay.addEventListener("click", closeDrawer);

    /* Section collapse toggles */
    drawer
      .querySelectorAll(".filter-section__toggle")
      .forEach(function (toggle) {
        toggle.addEventListener("click", function () {
          toggle.closest(".filter-section").classList.toggle("is-collapsed");
        });
      });

    /* Price range dual slider */
    var sliderMin = document.getElementById("priceSliderMin");
    var sliderMax = document.getElementById("priceSliderMax");
    var labelMin = document.getElementById("priceMinLabel");
    var labelMax = document.getElementById("priceMaxLabel");
    var fill = document.getElementById("priceRangeFill");

    function updatePriceRange() {
      if (!sliderMin || !sliderMax) return;
      var min = parseInt(sliderMin.value, 10);
      var max = parseInt(sliderMax.value, 10);
      if (min > max) {
        var tmp = min;
        min = max;
        max = tmp;
      }
      var total = parseInt(sliderMin.max, 10);
      if (fill) {
        fill.style.left = (min / total) * 100 + "%";
        fill.style.width = ((max - min) / total) * 100 + "%";
      }
      if (labelMin) labelMin.textContent = "₹" + min;
      if (labelMax) labelMax.textContent = "₹" + max;
    }

    /* Only treat price as a filter once the user actually drags a thumb this
       session — stops a stale/carried price cap from silently riding along
       with a vendor-only Apply (which used to push the badge to 2). */
    var priceTouched = false;
    function onPriceInput() {
      priceTouched = true;
      updatePriceRange();
    }
    if (sliderMin) sliderMin.addEventListener("input", onPriceInput);
    if (sliderMax) sliderMax.addEventListener("input", onPriceInput);
    updatePriceRange();

    /* Client-side vendor filter */
    var badge      = document.getElementById('filterBadge');
    var countEl    = document.getElementById('filterSelectedCount');
    var baseCount  = parseInt((badge && badge.textContent) || '0', 10) || 0;

    function updateBadge(vendorCount) {
      var total = baseCount + vendorCount;
      if (badge) {
        badge.textContent = total;
        if (total > 0) badge.removeAttribute('hidden');
        else badge.setAttribute('hidden', '');
      }
      if (countEl) {
        countEl.textContent = total > 0 ? total + ' selected' : '';
      }
    }

    function applyVendorFilter() {
      var checked = Array.from(
        drawer.querySelectorAll('[data-vendor-filter]:checked')
      ).map(function (cb) { return cb.value; });

      document.querySelectorAll('.product-card[data-vendor]').forEach(function (card) {
        if (!checked.length || checked.indexOf(card.dataset.vendor) !== -1) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });

      updateBadge(checked.length);
    }

    /* Apply filters */
    if (applyBtn) {
      applyBtn.addEventListener("click", function () {
        /* Client-side vendor filter (no Search & Discovery) */
        applyVendorFilter();
        closeDrawer();

        /* Server-side filters (price range + any named checkboxes) */
        var hasNamedFilters = Array.from(
          drawer.querySelectorAll('.filter-checkbox input[type="checkbox"]:checked')
        ).some(function (cb) { return cb.name; });

        var hasPriceFilter = priceTouched && sliderMin && sliderMax &&
          (parseInt(sliderMin.value, 10) > parseInt(sliderMin.min, 10) ||
           parseInt(sliderMax.value, 10) < parseInt(sliderMax.max, 10));

        if (!hasNamedFilters && !hasPriceFilter) return;

        /* filter within the CURRENT collection, not hardcoded /collections/all */
        var url = new URL(window.location.pathname, window.location.origin);
        url.searchParams.delete("page");

        if (priceTouched && sliderMin && sliderMax) {
          var min = parseInt(sliderMin.value, 10);
          var max = parseInt(sliderMax.value, 10);
          if (min > parseInt(sliderMin.min, 10)) url.searchParams.set("filter.v.price.gte", min);
          if (max < parseInt(sliderMax.max, 10))
            url.searchParams.set("filter.v.price.lte", max);
        }

        drawer
          .querySelectorAll('.filter-checkbox input[type="checkbox"]:checked')
          .forEach(function (cb) {
            if (cb.name && cb.value) url.searchParams.append(cb.name, cb.value);
          });

        window.location.href = url.toString();
      });
    }

    /* Reset filters */
    if (resetBtn) {
      resetBtn.addEventListener("click", function () {
        /* Un-hide vendor-filtered cards and reset badge */
        document.querySelectorAll('.product-card[data-vendor]').forEach(function (card) {
          card.style.display = '';
        });
        drawer.querySelectorAll('[data-vendor-filter]').forEach(function (cb) {
          cb.checked = false;
        });
        updateBadge(0);

        var url = new URL(window.location.pathname, window.location.origin);
        window.location.href = url.toString();
      });
    }
  }

  /* ── Know More toggle ── */
  function initKnowMore() {
    var toggle = document.getElementById("knowMoreToggle");
    var section = toggle ? toggle.closest(".know-more") : null;
    var body = document.getElementById("knowMoreBody");
    if (!toggle || !section || !body) return;

    function setHeight() {
      if (!section.classList.contains("know-more--collapsed")) {
        body.style.maxHeight = body.scrollHeight + "px";
        body.style.opacity = "1";
      }
    }

    setHeight();

    toggle.addEventListener("click", function () {
      var collapsed = section.classList.toggle("know-more--collapsed");
      toggle.setAttribute("aria-expanded", !collapsed);
      if (!collapsed) {
        body.style.maxHeight = body.scrollHeight + "px";
        body.style.opacity = "1";
      }
    });
  }

  /* ── Client-side product loading (re-run after category swaps) ──
     Mobile: infinite reveal — batches of PER_PAGE append automatically as the
     user nears the grid end (all cards are already server-rendered; this only
     flips display, zero network). Desktop: numbered pagination. */
  var ccRevealObserver = null;

  function initClientPagination() {
    var grid = document.querySelector(".products-grid");
    var countEl = document.querySelector(".products-section__count");
    var pagination = document.getElementById("jsPagination");
    if (!grid) return;

    /* tear down any observer from before an AJAX swap */
    if (ccRevealObserver) {
      ccRevealObserver.disconnect();
      ccRevealObserver = null;
    }

    var PER_PAGE = parseInt(grid.dataset.perPage, 10) || 16;
    var cards = Array.from(grid.querySelectorAll(".product-card"));
    var total = cards.length;
    var isMobile = window.matchMedia("(max-width: 47.9375rem)").matches;

    if (total === 0) return;

    function setCount(shown) {
      if (countEl)
        countEl.textContent = "1 – " + shown + " of " + total + " Products";
    }

    if (isMobile) {
      /* ---- infinite reveal ---- */
      var revealed = Math.min(PER_PAGE, total);
      cards.forEach(function (c, i) {
        c.style.display = i < revealed ? "" : "none";
      });
      setCount(revealed);

      if (revealed >= total) return;

      if (!("IntersectionObserver" in window)) {
        /* fail-silent fallback: reveal everything */
        cards.forEach(function (c) { c.style.display = ""; });
        setCount(total);
        return;
      }

      var sentinel = document.createElement("div");
      sentinel.className = "cc-reveal-sentinel";
      sentinel.style.height = "1px";
      /* inside the swapped subtree so a category swap discards it with the old DOM */
      grid.insertAdjacentElement("afterend", sentinel);

      ccRevealObserver = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        var next = Math.min(revealed + PER_PAGE, total);
        for (var i = revealed; i < next; i++) cards[i].style.display = "";
        revealed = next;
        setCount(revealed);
        if (revealed >= total) {
          ccRevealObserver.disconnect();
          ccRevealObserver = null;
          sentinel.remove();
        }
      }, { rootMargin: "600px 0px" });

      ccRevealObserver.observe(sentinel);
      return;
    }

    /* ---- desktop: numbered pagination (unchanged behavior) ---- */
    var pages = Math.ceil(total / PER_PAGE);
    var current = 1;

    function showPage(p) {
      current = p;
      var s = (p - 1) * PER_PAGE;
      cards.forEach(function (c, i) {
        c.style.display = i >= s && i < s + PER_PAGE ? "" : "none";
      });
      if (countEl)
        countEl.textContent =
          s + 1 + " – " + Math.min(s + PER_PAGE, total) + " of " + total + " Products";
      renderPagination();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function renderPagination() {
      if (pages <= 1 || !pagination) return;
      var h = "", p;

      h += current > 1
        ? '<a class="cc-pagination__btn cc-pagination__btn--prev" href="#" data-page="' + (current - 1) + '" aria-label="Previous">'
        : '<span class="cc-pagination__btn cc-pagination__btn--prev cc-pagination__btn--disabled" aria-disabled="true">';
      h += '<svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>';
      h += current > 1 ? "</a>" : "</span>";

      h += '<ul class="cc-pagination__list">';
      for (p = 1; p <= pages; p++) {
        h += p === current
          ? '<li><span class="cc-pagination__page cc-pagination__page--active" aria-current="page">' + p + "</span></li>"
          : '<li><a class="cc-pagination__page" href="#" data-page="' + p + '">' + p + "</a></li>";
      }
      h += "</ul>";

      h += current < pages
        ? '<a class="cc-pagination__btn cc-pagination__btn--next" href="#" data-page="' + (current + 1) + '" aria-label="Next">'
        : '<span class="cc-pagination__btn cc-pagination__btn--next cc-pagination__btn--disabled" aria-disabled="true">';
      h += '<svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>';
      h += current < pages ? "</a>" : "</span>";

      pagination.innerHTML = h;
      pagination.style.display = "";
      pagination.querySelectorAll("[data-page]").forEach(function (el) {
        el.addEventListener("click", function (e) {
          e.preventDefault();
          showPage(parseInt(el.dataset.page));
        });
      });
    }

    /* initial render without the smooth scroll-to-top */
    cards.forEach(function (c, i) {
      c.style.display = i < PER_PAGE ? "" : "none";
    });
    setCount(Math.min(PER_PAGE, total));
    renderPagination();
  }

  /* ── Sort dropdown (re-run after category swaps) ── */
  function initSortDropdown() {
    var dropdown = document.getElementById("sortDropdown");
    var btn = document.getElementById("sortBtn");
    var list = document.getElementById("sortList");
    if (!dropdown || !btn || !list) return;

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = dropdown.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });

    list.addEventListener("click", function (e) {
      var option = e.target.closest(".ps-sort-option");
      if (!option) return;
      var value = option.dataset.value;
      if (!value) return;
      /* sort within the CURRENT collection, not hardcoded /collections/all.
         "Featured" = the collection's own default/manual order (no sort_by
         param) — it used to redirect to the near-empty /collections/featured
         collection, which is why it showed one product. */
      var url = new URL(window.location.pathname, window.location.origin);
      if (value === "manual") {
        url.searchParams.delete("sort_by");
      } else {
        url.searchParams.set("sort_by", value);
      }
      window.location.href = url.toString();
    });
  }

  /* close the sort dropdown on outside click / Esc — bound once, survives swaps */
  document.addEventListener("click", function (e) {
    var dropdown = document.getElementById("sortDropdown");
    if (dropdown && !dropdown.contains(e.target)) dropdown.classList.remove("is-open");
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var dropdown = document.getElementById("sortDropdown");
    if (dropdown) dropdown.classList.remove("is-open");
  });

  /* ── Category switching: swap only the products area, keep the rail/chrome ── */
  function initCategoryAjax() {
    if (!document.querySelector(".categories-layout")) return;

    /* fetched collection HTML, keyed by URL — makes repeat switches instant */
    var ccPageCache = {};

    function setActive(url) {
      var path = new URL(url, window.location.origin).pathname.replace(/\/$/, "");
      document.querySelectorAll(".cat-strip .cat-card").forEach(function (card) {
        var href = (card.getAttribute("href") || "").split("?")[0].replace(/\/$/, "");
        card.classList.toggle("cat-card--active", href === path);
      });
      /* tell the rail the selection changed (glider moves + scrolls into view) */
      document.dispatchEvent(new CustomEvent("cc:activechange"));
    }

    function rebind() {
      initClientPagination();
      initSortDropdown();
      initFilterDrawer();
      initCollectionATC();
      fireViewItemList();
    }

    /* only the LATEST tap may touch the DOM — stale responses are dropped */
    var ccSwapSeq = 0;

    function fetchPage(url) {
      if (ccPageCache[url]) return Promise.resolve(ccPageCache[url]);
      var ctrl = "AbortController" in window ? new AbortController() : null;
      var timer = ctrl && setTimeout(function () { ctrl.abort(); }, 8000);
      return ehFetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (res) {
          if (timer) clearTimeout(timer);
          if (!res.ok) throw new Error(res.status);
          return res.text().then(function (html) {
            ccPageCache[url] = html;
            return html;
          });
        })
        .catch(function (err) {
          if (timer) clearTimeout(timer);
          throw err;
        });
    }

    function swapProducts(url, push) {
      var section = document.querySelector(".products-section");
      var inner = section ? section.querySelector(".products-section__inner") : null;
      if (!inner) {
        window.location.href = url;
        return;
      }

      var seq = ++ccSwapSeq;

      inner.style.transition = "opacity 0.15s ease";
      inner.style.opacity = "0.4";

      fetchPage(url)
        .then(function (html) {
          if (seq !== ccSwapSeq) return; /* superseded by a newer tap */
          var doc = new DOMParser().parseFromString(html, "text/html");
          var freshInner = doc.querySelector(".products-section__inner");
          if (!freshInner) throw new Error("no products markup");

          /* first viewport of images should pop in immediately, not lazy-load */
          Array.from(freshInner.querySelectorAll(".product-card__img-wrap img")).slice(0, 4)
            .forEach(function (img) {
              img.setAttribute("loading", "eager");
              img.setAttribute("fetchpriority", "high");
            });

          inner.replaceWith(freshInner);

          /* swap the filter drawer too so facets match the new collection */
          var drawer = document.getElementById("filterDrawer");
          var freshDrawer = doc.getElementById("filterDrawer");
          if (drawer && freshDrawer) drawer.replaceWith(freshDrawer);

          if (push) history.pushState({ ccAjax: true }, "", url);
          if (doc.title) document.title = doc.title;
          setActive(url);
          rebind();
          window.scrollTo({ top: 0, behavior: "smooth" });
        })
        .catch(function () {
          /* fail silently into a normal navigation — unless a newer tap
             already superseded this request */
          if (seq === ccSwapSeq) window.location.href = url;
        });
    }

    document.addEventListener("click", function (e) {
      var card = e.target.closest(".cat-card");
      if (!card) return;
      var href = card.getAttribute("href");
      if (!href || href.indexOf("/collections/") !== 0) return;
      e.preventDefault();
      if (card.classList.contains("cat-card--active")) return;
      /* optimistic: move the highlight the moment the tap lands — on fetch
         failure the fallback navigation renders the correct state anyway */
      setActive(href);
      swapProducts(href, true);
    });

    history.replaceState({ ccAjax: true }, "", window.location.href);
    window.addEventListener("popstate", function (e) {
      if (e.state && e.state.ccAjax) {
        swapProducts(window.location.pathname + window.location.search, false);
      }
    });

    /* normalize the highlight on every load, and re-assert it on bfcache
       back/forward restores (DOM resurrects from a previous swapped state) */
    setActive(window.location.href);
    window.addEventListener("pageshow", function (e) {
      if (e.persisted) setActive(window.location.href);
    });

    /* idle prefetch: warm the cache with every rail collection so most taps
       swap instantly; strictly fail-silent, one page at a time */
    function prefetchRail() {
      var hrefs = Array.from(document.querySelectorAll(".cat-card"))
        .map(function (c) { return c.getAttribute("href") || ""; })
        .filter(function (h) { return h.indexOf("/collections/") === 0 && !ccPageCache[h]; });

      (function next() {
        var url = hrefs.shift();
        if (!url) return;
        fetchPage(url).catch(function () {}).then(next);
      })();
    }

    if ("requestIdleCallback" in window) {
      requestIdleCallback(prefetchRail, { timeout: 5000 });
    } else {
      setTimeout(prefetchRail, 2000);
    }
  }

  /* ── Category rail (standard brand behavior, e.g. Blinkit/Zepto):
     the rail NEVER follows the page scroll — it scrolls only by direct
     swipe or when a selection needs bringing into view. A single "glider"
     bar at the left edge marks the active category and slides to the new
     one on selection. ── */
  function initRailBehavior() {
    if (window.innerWidth >= 768) return;
    var layout = document.querySelector(".categories-layout");
    var rail = layout ? layout.querySelector(".cat-strip") : null; /* the scroll column */
    var inner = rail ? rail.querySelector(".cat-strip__inner") : null; /* position:relative */
    if (!layout || !rail || !inner) return;

    var headerSection = document.querySelector(".shopify-section--header");

    /* the rail wrapper is position:sticky — it moves in native lockstep with
       the sticky header (incl. rubber-band bounces). JS only measures the
       header-stack height once and hands it to CSS. */
    function setHeaderVar() {
      if (!headerSection) return;
      /* use the header's own HEIGHT (its stuck size), not its bottom edge:
         the trust bar above it scrolls away, so the stack shrinks ~99→63px —
         a bottom-edge measure taken at load pinned the rail 36px too low
         once scrolled. Sticky's natural flow keeps the rail below the trust
         bar at page top; this offset handles the scrolled state. */
      var inner = headerSection.querySelector("height-observer, header, x-header");
      var h = (inner || headerSection).getBoundingClientRect().height;
      if (h > 40 && h < 300) layout.style.setProperty("--cc-header-h", h + "px");
    }

    /* the glider: one bar in CONTENT coordinates, so it scrolls with the
       list for free; only selection changes move it (CSS transition) */
    var glider = document.createElement("div");
    glider.className = "cat-rail-glider";
    inner.appendChild(glider);

    function updateGlider() {
      var active = rail.querySelector(".cat-card--active");
      if (!active) {
        glider.classList.remove("is-visible");
        return;
      }
      var circle = active.querySelector(".cat-card__img-wrap") || active;
      var innerBox = inner.getBoundingClientRect();
      var box = circle.getBoundingClientRect();
      glider.style.height = box.height + "px";
      glider.style.transform =
        "translateY(" + (box.top - innerBox.top) + "px)";
      glider.classList.add("is-visible");
    }

    function revealActive() {
      var active = rail.querySelector(".cat-card--active");
      if (active && active.scrollIntoView) {
        active.scrollIntoView({ block: "nearest", behavior: "smooth" });
      }
    }

    document.addEventListener("cc:activechange", function () {
      updateGlider();
      revealActive();
    });

    window.addEventListener("resize", function () {
      setHeaderVar();
      updateGlider();
    });

    window.addEventListener("pageshow", function (e) {
      if (!e.persisted) return;
      setHeaderVar();
      updateGlider();
      revealActive();
    });

    setHeaderVar();
    /* re-measure after fonts/announcement marquee settle */
    setTimeout(function () {
      setHeaderVar();
      updateGlider();
    }, 500);
    updateGlider();
    revealActive();
  }

  /* ── Cart drawer helper (matches Prestige extractSectionId) ── */
  function getDrawerSectionId() {
    var el = document.querySelector("cart-drawer");
    if (!el) return null;
    var section = el.closest(".shopify-section");
    return section ? section.id.replace("shopify-section-", "") : null;
  }

  /* ── ATC buttons on collection grid (delegated) ── */
  function initCollectionATC() {
    var grid = document.querySelector(".products-grid");
    if (!grid) return;

    grid.addEventListener("click", function (e) {
      var btn = e.target.closest(".product-card__atc-btn");
      if (!btn || btn.disabled) return;

      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;

      var sectionId = getDrawerSectionId();
      var body = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (sectionId) body.sections = sectionId;

      ehCartPost("/cart/add.js", body)
        .then(function (res) {
          return res.json();
        })
        .then(function (addResp) {
          return ehFetch("/cart.js")
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              if (addResp.sections) cart.sections = addResp.sections;
              return cart;
            });
        })
        .then(function (cart) {
          document.querySelectorAll("[data-cart-count]").forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: { baseEvent: "variant:add", cart: cart }
          }));
          /* ── Analytics ── */
          var card = btn.closest('.product-card');
          var title = card ? ((card.querySelector('.product-card__name') || {}).textContent || '').trim() : '';
          var priceEl = card ? card.querySelector('.price-current') : null;
          var priceVal = priceEl ? parseFloat(priceEl.textContent.replace(/[^\d.]/g, '')) || 0 : 0;
          if (window.fireAddToCartEvent) window.fireAddToCartEvent(String(variantId), title, priceVal, 1);
          var orig = btn.innerHTML;
          btn.innerHTML =
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
          setTimeout(function () {
            btn.innerHTML = orig;
            btn.disabled = false;
          }, 1200);
        })
        .catch(function () {
          btn.disabled = false;
        });
    });
  }

  /* ── Boot ── */
  function fireViewItemList() {
    if (!window.gtag) return;
    var cards = document.querySelectorAll('.product-card');
    if (!cards.length) return;
    var items = [];
    cards.forEach(function(card, i) {
      var nameEl = card.querySelector('.product-card__name');
      var priceEl = card.querySelector('.price-current');
      var atcBtn  = card.querySelector('.product-card__atc-btn');
      var title   = nameEl ? nameEl.textContent.trim() : '';
      var price   = priceEl ? parseFloat(priceEl.textContent.replace(/[^\d.]/g, '')) || 0 : 0;
      var vid     = atcBtn  ? atcBtn.dataset.variantId || '' : '';
      items.push({ item_id: String(vid), item_name: title, price: price, index: i + 1 });
    });
    gtag('event', 'view_item_list', { currency: 'INR', items: items });
  }

  /* ── Product-card "See More / See Less" description toggle ── */
  function initSeeMore() {
    // Delegated on document so it keeps working after AJAX pagination / category swaps.
    document.addEventListener("click", function (e) {
      try {
        var btn = e.target.closest("[data-see-more]");
        if (!btn) return;
        var wrap = btn.closest("[data-desc]");
        if (!wrap) return;
        var expanded = wrap.classList.toggle("is-expanded");
        btn.setAttribute("aria-expanded", expanded ? "true" : "false");
        btn.textContent = expanded ? "See Less" : "... See More";
      } catch (err) {
        /* fail silently — never crash the storefront */
      }
    });
  }

  function init() {
    initCategoryStrip();
    initFilterDrawer();
    initKnowMore();
    initCollectionATC();
    initClientPagination();
    initSortDropdown();
    initCategoryAjax();
    initRailBehavior();
    initSeeMore();
    fireViewItemList();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
